import { useState } from "react";
import { MainStackScreenProps } from "../../navigation/Navigation.types";

export const PLAYER_TABS: { [key: string]: { alias: string; title: string } } = {
  stats: { alias: "stats", title: "Stats" },
  matches: { alias: "matches", title: "Matches" },
  groups: { alias: "groups", title: "Teams" },
};

interface IEqipaCardHook {
  selectedTab: string | null;
  playerTabs: Array<{ alias: string; title: string }>;
  onTabSelected: (tab: string) => void;
}

export function useEqipaCard({ navigation, route }: MainStackScreenProps<"eqipa-card">): IEqipaCardHook {
  const [selectedTab, setSelectedTab] = useState<string | null>(PLAYER_TABS.stats.alias);
  const playerTabs = Object.values(PLAYER_TABS);

  const onTabSelected = (alias: string) => {
    setSelectedTab(alias);
  };

  return { selectedTab, playerTabs, onTabSelected };
}
